'use client'

/**
 * The projects list page.
 *
 * The route file at `app/app/projects/page.tsx` keeps the default export Next.js
 * resolves by name and delegates here — ADR 0010: a file the framework resolves is an adapter and owns nothing.
 */

import { useState } from 'react'
import { PlusIcon } from '@phosphor-icons/react'
import { Button } from '@/ui/button'
import { useProjects } from './select-projects'
import { useProjectStats } from './select-project-stats'
import { ProjectCreateForm } from './project-create-form'
import { ProjectList } from './project-list'

export function ProjectsPage() {
  const [showCreateForm, setShowCreateForm] = useState(false)
  const { data: projects, isLoading } = useProjects()
  const { data: stats } = useProjectStats()

  return (
    <div className="mx-auto w-full max-w-3xl">
      {/* Page header */}
      <div className="flex items-center justify-between py-6">
        <h1 className="text-foreground text-xl font-normal">Projects</h1>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setShowCreateForm((prev) => !prev)}
          aria-label="New project"
        >
          <PlusIcon className="h-4 w-4" weight="bold" />
          New project
        </Button>
      </div>

      {/* Create form */}
      <ProjectCreateForm
        visible={showCreateForm}
        onClose={() => setShowCreateForm(false)}
      />

      {/* Project list */}
      <div className={showCreateForm ? 'mt-4' : ''}>
        {isLoading ? (
          <div className="py-12 text-center">
            <p className="text-muted-foreground text-sm">Loading projects...</p>
          </div>
        ) : (
          <ProjectList projects={projects} stats={stats} />
        )}
      </div>
    </div>
  )
}
